/**
 * A premium as US dollars: whole dollars without cents (`$1,840`), cents when it has them
 * (`$1,840.50`).
 */
export function moneyText(amount: number): string {
  const cents = !Number.isInteger(amount);
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: cents ? 2 : 0,
    maximumFractionDigits: cents ? 2 : 0,
  }).format(amount);
}
